import * as Toast from "@radix-ui/react-toast";
import { useState } from "react";
import "./Toast.css";

export function SuccessToast({
  open,
  onOpenChange,
  message,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  message: string;
}) {
  const handleClose = () => onOpenChange(false);
  return (
    <Toast.Provider duration={4500}>
      <Toast.Root
        open={open}
        onOpenChange={onOpenChange}
        className="custom-toast-root"
        onClick={handleClose}
      >
        <button
          className="toast-close-button"
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
        >
          ×
        </button>
        <div className="custom-toast-content">
          <div className="custom-toast-content">
            <p>
              Hay momentos en la vida que
              <br />
              son especiales por sí solos.
            </p>
            <br />
            <p>
              Compartirlos con las personas
              <br />
              que quieres los convierte en
              <br />
              inolvidables.
            </p>
            <br />
            <p>
              Gracias por formar parte de
              <br />
              este día.
            </p>
            <br />
            <p className="toast-initials">F|F</p>
          </div>
        </div>
      </Toast.Root>
      <Toast.Viewport className="custom-toast-viewport" />
    </Toast.Provider>
  );
}
